@use "../../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../../styles/layout";

.container {
    align-items: flex-start;
    display: flex;
    gap: 3vw;
    justify-content: center;
    padding: 16px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        align-items: center;
        flex-direction: column;
    }
}

.title {
    font-weight: 700;
    text-transform: uppercase;
}

.changeLocationLink {
    color: var(--color-lobster);
    text-transform: uppercase;

    & svg {
        height: 16px;
        fill: var(--color-lobster);
        stroke: var(--color-lobster);
        width: 16px;
        transform: translateY(2px);
    }
}

.today {
    flex-direction: column;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;

    &::before {
        display: none;
    }

    & time {
        font-weight: 400;
    }

    & > time:first-of-type {
        margin-top: 8px;
        line-height: 0.5;
    }
}

.options {
    &::before {
        display: none;
    }
}

.locationContainer {
    @include breakpoint.breakpoint(layout.$belowMedium) {
        align-items: center;
        display: flex;
        flex-direction: column;
    }
}

.hoursContainer {
    display: flex;
    flex-direction: column;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        align-items: center;
        flex-direction: row;
        gap: 5vw;
    }
}
